

















































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import constants      from '@/constants';

import CoordinatePair from '@/models/CoordinatePair';

import Mapbox from 'mapbox-gl';

/**
 * TODO MAJOR, HARD...
 *
 * This file contains a ton of 'any' .ts types b/c of this vue-mapbox dependency.
 *
 * There's a way to declare types for the whole thing, and that's what I need to do.
 *
 * But not now, in the middle of a major refactor and don't want to get any further
 * into this rathole.
 */
import {
  MglMap,
  MglPopup,
  MglMarker,
  MglAttributionControl,
  MglNavigationControl,
  MglGeolocateControl,
  MglScaleControl
} from 'vue-mapbox';
import SiteReference from '@/models/SiteReference';

const DETAIL_ZOOM_LEVEL = 11;

const centers            = [

  // Fontanelle
  [-110.0590425, 41.9849489],

  // Jackson
  [-110.877221, 43.4844835],

  // near Honululu
  [-158.0200448, 21.4460309],

  // Olympic Peninsula
  [-123.6292957, 47.8043704],

  // Puerto Rico
  [-67.7071782, 18.2052267],

  // Ashton Id
  [-111.4579733, 44.0746486],

  // Niagra Falls
  [-79.1580743, 43.0539111],

  // New Orleans
  [-90.0226483, 30.0329222],

  // Moab
  [-109.5689281, 38.5743966]

];

@Component({
  name: 'Map',
  components: {
    MglMap,
    MglPopup,
    MglMarker,
    MglAttributionControl,
    MglNavigationControl,
    MglGeolocateControl,
    MglScaleControl,
  },

})

export default class Map extends Vue {

  //
  // Data properties
  //
  // FIXME: This can't be here. Right?
  accessToken = 'pk.eyJ1Ijoiam9obmJhcnJ5MzMzIiwiYSI6ImNrMWZoZWcxeDB0emwzY3MxOW53d2FnMmYifQ.ECUXCMrnFJ1k5DN3VVevCw';
  mapStyle    = 'mapbox://styles/johnbarry333/ck1fhfbzi20kk1cpgt0g61uh8';

  // Expose a route name from a constant for a router-link
  miniDetailRouteName   = constants.RouteNames.MiniDetail;

  currentStations   = [];

  // Jellystone
  // center            = [-110.5885, 44.4280];
  zoom              = 8;

  // Colorado
  //
  // center            : [-106.2152399, 39.2195795],

  // Colorado
  // center            = [-107.8200123, 39.5448406];

  // Fontanelle


  center: Array<number> = [];

  padding           = {left: 300, right: 0};

  // Not type safe :/
  mapbox = {};


  //
  // Computed properties
  //

  /**
   * Return a view of the search results in the store MINUS the currently
   * active site.
   */
  get searchResults() {

    // Add each element of search result to a new array, checking that each element
    // isn't an active site OR part of Favorites.

    let mapSearchResults = this.$store.state.mapSearchResults.currentSearch.siteRefs.filter((searchResult: SiteReference) => {

      // Return false if it's the active site
      if (this.activeSiteReference &&
          this.activeSiteReference.siteNumber === searchResult.siteNumber) {
        return false;
      }

      return true;
    });

    return mapSearchResults;
  }

  /**
   * Search results, converted into a JS Object representation of GeoJSON, the input
   * format required by MapBox to do clustering
   *
   * GEO JSON example: see https://docs.mapbox.com/mapbox-gl-js/assets/earthquakes.geojson
   */
  get searchResultsGeoJSONObject() {

    const searchResultsGeoJSONEntries = this.searchResults.map((result: SiteReference) => {
      return {
        type : "Feature",
        properties : {
          siteNumber: result.siteNumber,
          state: result.state.toLowerCase()
        },
        geometry : {
          type : "Point",
          coordinates : [result.lon, result.lat, 0.0]
        }
      }
    });

    const geoJSON = {
      "type": "FeatureCollection",
      "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:OGC:1.3:CRS84" } },
      "features": searchResultsGeoJSONEntries
    };

    return geoJSON;
  }

  get activeSiteReference(): SiteReference {
    return this.$store.state.activeSite.reference;
  }

  get userLocation(): CoordinatePair {
    return this.$store.state.uiState.userLocation;
  }

  get isTrayOpen(): boolean {
    return this.$store.state.uiState.isTrayOpen;
  }

  //
  // Watchers
  //

  @Watch('activeSiteReference')
  onActiveSiteChanged(value: SiteReference, oldValue: SiteReference) {
    if (!value.isNullSite) {
      this.flyToActiveSite();
    }
  }

  @Watch('userLocation')
  onUserLocationChange() {
    this.$nextTick(() => {
      if (this._getMapboxGlMapRef() && this.userLocation.lat) {
        this.flyTo(this.userLocation.lat, this.userLocation.lng, DETAIL_ZOOM_LEVEL);
      }
    })
  }

  /**
   * When search results change, redraw search results on map
   */
  @Watch('searchResults')
  onSearchResultsChange(value: Array<SiteReference>, oldValue: Array<SiteReference>) {

    // Only redraw the map when the new search results are different from the old ones
    const resultsAreSame = (value.length === oldValue.length)
                        && (JSON.stringify(value.map(el => el.siteNumber)) === JSON.stringify(oldValue.map(el => el.siteNumber)))
    if (!resultsAreSame) {
      console.log('Map: search results changed')
      this.drawClusteredSearchResults();
    }

    // IMPORTANT: ROUTING LOGIC!
    //
    // If we're on the 'near me' route, then push the map search results to the search results widget.
    //
    // Yuck.
    if (this.$route.name === constants.RouteNames.NearLocation) {
      this.$store.dispatch("setSearchResults", this.$store.state.mapSearchResults.currentSearch);
    }
  }

  /**
   * When tray opens or closes, re-center map in visible map space
   */
  @Watch('isTrayOpen')
  onIsTrayOpenChange() {
    if (this._getMapboxGlMapRef()) {
      this.easeToOffset();
    }
  }

  //
  // Lifecycle Methods
  //

  created() {

    // Pick a random center to show the user
    this.center = centers[Math.floor((Math.random() * centers.length))];
  }

  /**
   * Per docs, set mapbox-gl library in order to use it in template
   */
  mounted() {
    this.mapbox = Mapbox;
  }

  //
  // Methods
  //

  /**
   * Initializes the map...
   *
   * ...runs as a callback invoked by the Mapbox instance once it's loaded
   */
  async init() {

    // MAGIC / SHITTY CODE ALERT...
    //
    // Deal with the dumb site stub we have to have in place in order for Vuex to work
    if (!this.activeSiteReference.isNullSite) {
      this.flyTo(this.activeSiteReference.lat, this.activeSiteReference.lon, DETAIL_ZOOM_LEVEL);
    }
    else {
      await this.searchInMap();
      this.drawClusteredSearchResults();
    }

    const map = this._getMapboxGlMapRef();

    // Search in map on every moveend. This is the only way to find out when
    // the map finishes moving... there's no callback that runs after flyTo animation
    //
    // It's possible to differentiate between different types of moves...
    //
    // see https://github.com/mapbox/mapbox-gl-js/issues/1794
    map.on('moveend', () => {
      this.searchInMap();
    });

    /**
     * On cluster click:
     *
     * - zoom map
     * - recluster shit
     */
    map.on('click', 'clusters', (e: any) => {
      const features = map.queryRenderedFeatures(e.point, {
        layers: ['clusters']
      });

      const clusterId = features[0].properties.cluster_id;
      map.getSource('sites').getClusterExpansionZoom(
        clusterId,

        // TODO: test this. when would it ever run?
        (err: Error, zoom: number) => {
          if (err) return;

          map.easeTo({
            center: features[0].geometry.coordinates,
            zoom: zoom
          });
        }
      );
      }
    );

    /**
     * On unclustered point click:
     *
     * - open site mini detail view
     * - (which zooms and pans map)
     */
    map.on('click', 'unclustered-point', (e: any) => {
      if (e.features.length && e.features[0].properties && e.features[0].properties.siteNumber) {
        this.$router.push({name: this.miniDetailRouteName, params: {
          state : e.features[0].properties.state,
          siteNumber : e.features[0].properties.siteNumber
        }});

        // Force open tray
        this.$store.dispatch('setIsTrayOpen', true);
      }
    });
  }

  /**
   * Get the map's current bounds and trigger a map search route
   */
  async searchInMap() {
    let bounds = this._getMapboxGlMapRef().getBounds()

    const southwestBound = bounds._sw;
    const northeastBound = bounds._ne;

    // IMPORTANT: This only works because center point is only ever displayed in 'near my location'
    //
    // The given SearchResult will always think the center is wherever the user is
    const centerPoint = this.$store.state.uiState.userLocation;

    this.$store.dispatch('doMapSearch', { southwestBound, northeastBound, centerPoint  });
  }

  /**
   * Handle user clicking the 'Use My Location' button
   *
   * ARCHITECTURE: use Vue composition API for this (duplicate code w/ Autocomplete)
   */
  async handleGeolocate() {
    try {
      // TODO TYPE SAFETY - Figure out how to stub this
      const coordinates = await (this as any).$getLocation()

      const lat = coordinates.lat.toFixed(4);
      const lng = coordinates.lng.toFixed(4);

      this.$router.push({ name: constants.RouteNames.NearLocation, query: { lat, lng } });

    } catch(e) {
      this.$emit('geolocationerror');
    }
  }

  // This is super sketchy... just preserving existing behavior and trying to put a bandaid
  // on a problem to get around .ts
  _getMapboxGlMapRef(): any {
    return (this as any).$refs.theMap.map;
  }

  //
  // Map actions
  //

  /**
   * Fly to the given location on the map
   */
  flyTo(lat: number, lng: number, zoom: number) {
    const padding = this.getCenterOffsetPadding();

    this._getMapboxGlMapRef().flyTo({
      padding,
      center: [lng, lat],
      zoom
    });
  }

  /**
   * Fly to the location of the active site
   */
  flyToActiveSite() {
    if (this._getMapboxGlMapRef()) {
      this.flyTo(this.activeSiteReference.lat, this.activeSiteReference.lon, DETAIL_ZOOM_LEVEL);
    }
  }

  /**
   * Ease to the offset of center position needed to put the marker in the center of the visible map space, accounting for
   * the tray in either desktop / mobile modes
   */
  easeToOffset() {
    const padding = this.getCenterOffsetPadding();
    this._getMapboxGlMapRef().easeTo({
      padding,
    });
  }

  /**
   * The map uses padding for center offsets
   *
   * There are four possible positions:
   *
   * Desktop
   * - 1. Tray open
   * - 2. Tray closed
   *
   * Mobile
   * - 3. Tray open
   * - 4. Tray closed
   */
  getCenterOffsetPadding() {

    const padding = {
      left: 0,
      bottom: 0
    };

    // When tray is open, we offset the center of the map
    if (this.isTrayOpen) {

      // Desktop offset
      if (this.$store.state.uiState.isDesktop) {
        padding.left = parseInt(constants.StructuralStyles.DesktopTrayWidth);
      }

      // Mobile offset
      else {

        //
        //                Viewport
        const mapHeight = window.document.body.getBoundingClientRect().height;

        //                                                                                                   // Add back footer height
        padding.bottom = (this.$store.state.uiState.isShortMobile ? (mapHeight * .75) : (mapHeight * .65));

        // TODO expose and use shortmobile thing from uiState
        // TODO: need to compute this :/
        //
        // padding.bottom = "500";
      }
    }

    // const padding = {
    //   left : (this.$store.state.uiState.isDesktop && this.isTrayOpen) ? constants.StructuralStyles.DesktopTrayWidth : 0,
    //   bottom : (!this.$store.state.uiState.isDesktop && this.isTrayOpen) ? (parseInt(constants.StructuralStyles.MobileTrayExpandedHeight) - parseInt(constants.StructuralStyles.MobileTrayCollapsedHeight)) : 0
    // }
    return padding;
  }

  //
  // Map clustering logic
  //
  // TODO: Extract map clustering logic
  //

  /**
   * Draw search results using mapbox's clustering APIs
   *
   * https://docs.mapbox.com/mapbox-gl-js/example/cluster/
   */
  drawClusteredSearchResults() {

    // const brightGreen = "#3AD428";
    const brightBlue = "#3AA0D9";
    if (!this._getMapboxGlMapRef()) {
      return;
    }
    let map = this._getMapboxGlMapRef();

    const sourceId = 'sites';

    // If a clustered source already exists, remove it
    if (map.getSource(sourceId)) {

      this._removeClustersLayer(map);
      this._removeClusterCountLayer(map);
      this._removeUnclusteredPointsLayer(map);

      map.removeSource(sourceId);
    }

    map.addSource(sourceId, {
      type: 'geojson',
      data: this.searchResultsGeoJSONObject,

      cluster: true,
      clusterMaxZoom: 12,
      clusterRadius: 20,
    });

    this._addClustersLayer(map, sourceId, brightBlue);
    this._addClusterCountLayer(map, sourceId);
    this._addUnclusteredPointsLayer(map, sourceId, brightBlue);
  }

  _addClustersLayer(map: any, sourceId: any, color: string) {

    map.addLayer({
      id: 'clusters',
      type: 'circle',
      source: sourceId,
      filter: ['has', 'point_count'],


      // NOTE: to vary size / color by point count, see original example, or this
      //
      // https://docs.mapbox.com/mapbox-gl-js/style-spec/#expressions-step
      paint: {
        'circle-color': color,
        // 'fill-outline-color': 'white',
        'circle-radius': 17,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#fff'
      }
    });
  }

  _removeClustersLayer(map: any) {
    map.removeLayer('clusters');
  }

  _addClusterCountLayer(map: any, sourceId: string) {
    map.addLayer({
      id: 'cluster-count',
      type: 'symbol',
      source: sourceId,
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
      }
    });
  }

  _removeClusterCountLayer(map: any) {
    map.removeLayer('cluster-count');
  }

  _addUnclusteredPointsLayer(map: any, sourceId: any, color: any) {

    const unclusteredPointSize = this.$store.state.uiState.isDesktop ? 7 : 10;
    map.addLayer({
      id: 'unclustered-point',
      type: 'circle',
      source: sourceId,
      filter: ['!', ['has', 'point_count']],

      paint: {
        'circle-color': color,
        'circle-radius': unclusteredPointSize,
        'circle-stroke-width': 2,
        'circle-stroke-color': '#fff'
      }
    });
  }

  _removeUnclusteredPointsLayer(map: any) {
    map.removeLayer('unclustered-point');
  }

}

